import React from "react";
import { Text, Stack, Flex, Box } from "@chakra-ui/react";
import { textSecondary, textPrimary } from "../../../utils/colors";

export const columnsMobile = (translate, currencySymbol) => {
  return [
    {
      Header: translate("service.service"),
      accessor: "serviceName",
      Cell: ({ row }) => {
        const { service, teeth, order } = row.original;
        // console.log("row.original", row.original);

        return (
          <Flex align="flex-start">
            <Text
              minWidth="17px"
              overflow="hidden"
              whiteSpace="nowrap"
              fontSize="xs"
              fontWeight="500"
              color={textSecondary}
              mr={0.5}
            >
              {order}.
            </Text>
            <Stack gap={0}>
              <Text
                fontSize="0.8rem"
                color={textPrimary}
                fontWeight="500"
                isTruncated // This will add ellipsis
                maxW="280px"
              >
                {(service && service.name && service.name) || "-"}
              </Text>
              {teeth && teeth.length > 0 && (
                <Flex maxW="280px">
                  <Text fontSize="xs" color={textSecondary} fontWeight="500">
                    {teeth && teeth.length > 0 ? teeth.join(", ") : "-"}
                  </Text>
                </Flex>
              )}
            </Stack>
          </Flex>
        );
      },
    },

    {
      Header: () => (
        <Text w="100%" textAlign="right">
          {translate("common.total")}
        </Text>
      ),
      accessor: "total",
      // width: 50,
      Cell: ({ row }) => {
        const { totalPrice } = row.original;

        return (
          <>
            <Text
              fontSize="xs"
              color={textPrimary}
              fontWeight="500"
              textAlign="right" // ← Add this line
            >
              {totalPrice} €
            </Text>
          </>
        );
      },
    },
  ];
};
